import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ManifestoSection.module.scss';

import manifestoImage from '../../../assets/images/Landing/manifiesto.jpg';

export const ManifestoSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className={styles['manifesto']} id="comunidad">
            <div className={styles['manifesto__content']}>
                
                <div className={styles['manifesto__media']}>
                    <img 
                        src={manifestoImage} 
                        alt={t('landing.manifesto.imageAlt', 'Persona contemplando el horizonte')} 
                        className={styles['manifesto__bg']} 
                    />
                    <div className={styles['manifesto__overlay']} />
                </div>

                <div className={styles['manifesto__copy']}>
                    <h2 className={styles['manifesto__title']}>
                        {t('landing.manifesto.title', 'Para quienes sienten que tiene que haber otra forma')}
                    </h2>
                    
                    <p className={styles['manifesto__text']}>
                        {t('landing.manifesto.para1', 'Un espacio para quienes buscan una forma más humana, consciente e integradora de acompañar su salud y bienestar. Para quienes desean comprenderse mejor, participar activamente en su proceso y acercarse a profesionales y enfoques diversos desde una experiencia más amplia, cercana y respetuosa.')}
                    </p>
                    
                    <p className={styles['manifesto__text']}>
                        {t('landing.manifesto.para2', 'En Bodhiwell creemos en sumar, no excluir. En abrir espacios de encuentro, intercambio y acompañamiento donde distintas miradas puedan convivir con sentido. Este lugar crece con cada persona que decide acercarse.')}
                    </p>
                </div>

            </div>
        </section>
    );
};